export const nav = {
  dashboard: "Dashboard",
  users: "Users",
  adminRoles: "Admin Roles",
  subscriptions: "Subscriptions",
  subscriptionMatrix: "Subscription Matrix",
  stockAnalyses: "Stock Analyses",
  topHalalStocks: "Top Halal Stocks",
  portfoliosPreMade: "Portfolios (pre-made)",
  readyMadePortfolio: "Ready-Made Portfolio",
  akindaAcademy: "Akinda Academy",
  articles: "Articles",
  articleCategories: "Article Categories",
  webinars: "Webinars",
  supportTickets: "Support Tickets",
  notifications: "Notifications",
  home: "Home",
  marketNews: "Market News",
  stockScreener: "Stock Screener",
  etfScreener: "ETF Screener",
  screening: "Screening",
  insiderBySector: "Insider By Sector",
  dividend: "Dividend",
  investingCalculator: "Investing Calculator",
  zakatCalculator: "Zakat Calculator",
  purificationCalculator: "Purification Calculator",
  myPortfolio: "My Portfolio",
  portfolioTracking: "Portfolio Tracking",
  portfolioBacktesting: "Portfolio Backtesting",
  akindaAi: "Akinda AI",
  games: "Games",
  community: "Community",
  backtesting: "Backtesting",
  promocodes: "Promocodes",
  finance: "Finance",
  referral: "Referral",
  onboardingQuestions: "Onboarding Questions",
  onboardingStats: "Onboarding Analytics",
} as const;
